<template>
    <v-container xs12>
        <v-layout xs12 wrap id="cardTableHeader" align-center>
            <v-flex class="title" fill-height grow pa-1>
                <slot name="title"></slot>
            </v-flex>
            <v-flex v-if="hasButtons" class="btns" shrink pa-1 fill-height text-xs-right style="height: 100% !important">
                <slot id="buttonContainer" name="buttons"></slot>
            </v-flex>
        </v-layout>
        <v-layout xs12 wrap id="cardTableContent">
            <v-flex xs12 id="content">
                <slot name="content" ref="content"></slot>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "CardTable",
        computed: {
            hasButtons: function() {
                return this.$slots.buttons !== undefined
            }
        }
    }
</script>

<style lang="scss" scoped>

#cardTableHeader {
    min-height: 56px;
}

    .btns > * {
        margin: 0;
        // height: 99%;
        // background-color: green;
        box-shadow: none;
        // padding: 1px 5px 1px 5px; // This is a small trick to avoid having the edges blurred
    }
    .title {
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0.02em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }



    #content {
        padding: 15px 15px 15px 15px;
    }


    #cardTableHeader {

        // height: 56px;
        // background-color: #f5f5f5;
        box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
        background-color:#f5f5f5;
        color:rgba(0,0,0,0.87);
        padding-left: 15px;
        padding-right: 15px;
        // min-height: 60px;

    }

    #cardTableContent {
        background-color:#fff;
        border-color:#fff;
        color:rgba(0,0,0,0.87);
        box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
        text-decoration: none;
    }

</style>


